export default "__VITE_ASSET__C90MkJCI__"